<template>
  <div>
    <px-view-header title="Integração" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs" />
    <v-card class="rounded-card">
      <v-card-text>
        <px-listagem-logs-header
          :on-click-refresh="onClickRefresh"
          :loading="loading"
          @change="onChangeFilter"/>
        <div>
          <px-lista-logs
            :logs="logs"
            :loading="loading"
            :on-change-options="onChangeOptions"
            :options-list="optionsList"
            @update="onClickRefresh"/>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/painel-integracao/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import IntegracaoService from '@/api/integracao-service';
import ListagemLogsHeader from './ListagemLogsHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      logs: {
        content: [],
        total: 0,
      },
      optionsList: {},
      loading: false,
      breadcrumbs: [
        { text: 'Minha empresa' },
        { text: 'Integração' },
      ],
    };
  },
  computed: {
    ...mapGetters('painelIntegracao', ['stringFilter', 'listOptions']),
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['idEntidade']),
  },
  methods: {
    ...mapActions('painelIntegracao', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onClickRefresh() {
      this.getLogs();
    },
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getLogs();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getLogs();
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getLogs() {
      this.loading = true;

      const { limit, offset } = this.listOptions;
      IntegracaoService.getLogsIntegracao({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.logs = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxListagemLogsHeader: ListagemLogsHeader,
  },
};
</script>
